import axios from "axios";

import Config from "src/config";

const v2_actionCriarCampanhaRastreamento = (clienteId, data ) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/${clienteId}/marketing/campanhas-rastreamento`,
        data
    });
};
export default v2_actionCriarCampanhaRastreamento;
